import styled from 'styled-components';

export const Page = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
`;

export const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	width: 100%;
	gap: 30px;
	padding: 20px;
	overflow-y: auto;
	max-height: 100vh;
	padding-bottom: 100px;
`;

export const TableWrapper = styled.div`
	max-height: 80%;
	overflow: scroll;
`;
